import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AlbumGrid from "@/components/AlbumGrid";
import { ALBUMS } from "@/data/photos";
import { motion } from "framer-motion";
import { HandHeart, Package, Users } from "lucide-react";

export default function ActionsHumanitaires() {
  const actionsAlbum = ALBUMS.find((a) => a.id === "actions")!;
  const eventsAlbum = ALBUMS.find((a) => a.id === "events")!;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[55vh] flex items-end pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <img src={actionsAlbum.cover} alt="Actions humanitaires FGNB" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[oklch(0.12_0.06_150/0.95)] via-[oklch(0.2_0.08_150/0.6)] to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <span className="inline-block text-emerald-400 text-sm font-semibold uppercase tracking-[0.15em] mb-3">Sur le terrain</span>
            <h1 className="text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Actions <span className="text-emerald-300">Humanitaires</span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-muted-foreground leading-relaxed text-base max-w-3xl mx-auto text-center mb-16">
            La FGNB mène des actions concrètes sur le terrain : distribution de vivres, kits scolaires, soutien aux familles
            vulnérables et organisation d'événements communautaires pour les enfants et les jeunes.
          </motion.p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mb-20">
            {[
              { icon: Package, label: "Kits distribués", value: "500+" },
              { icon: Users, label: "Familles aidées", value: "300+" },
              { icon: HandHeart, label: "Événements", value: "20+" },
            ].map(({ icon: Icon, label, value }) => (
              <motion.div key={label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                className="bg-card border border-border rounded-3xl p-6 text-center hover:border-emerald-400/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-xl bg-emerald-500/10 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-5 h-5 text-emerald-500" />
                </div>
                <p className="text-3xl font-bold text-foreground mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{value}</p>
                <p className="text-xs text-muted-foreground">{label}</p>
              </motion.div>
            ))}
          </div>

          {/* Album 1 - Distribution */}
          <div className="mb-16">
            <span className="inline-block text-accent text-sm font-semibold uppercase tracking-[0.15em] mb-2">Album 1</span>
            <h2 className="text-3xl font-bold text-foreground mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {actionsAlbum.title}
            </h2>
            <AlbumGrid photos={actionsAlbum.photos} columns={3} />
          </div>

          {/* Album 2 - Events */}
          <div>
            <span className="inline-block text-accent text-sm font-semibold uppercase tracking-[0.15em] mb-2">Album 2</span>
            <h2 className="text-3xl font-bold text-foreground mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {eventsAlbum.title}
            </h2>
            <AlbumGrid photos={eventsAlbum.photos} columns={3} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
